module.exports = __webpack_public_path__ + "static/footer-bg-75604e784e43e6f701a3d7a16770156a.jpg";